function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

var TableRowColumn =
/*#__PURE__*/
function (_Component) {
  _inherits(TableRowColumn, _Component);

  function TableRowColumn() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, TableRowColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = TableRowColumn.__proto__ || Object.getPrototypeOf(TableRowColumn)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "onClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (_this.props.disableClick) {
          event.stopPropagation();
          return;
        }

        if (_this.props.onClick) {
          var _this$props;

          (_this$props = _this.props).onClick.apply(_this$props, [event].concat(_toConsumableArray(_this.props.onClickParams || [])));
        }
      }
    }), _temp));
  }

  _createClass(TableRowColumn, [{
    key: "render",
    value: function render() {
      var _cx;

      var _props = this.props,
          blockName = _props.blockName,
          children = _props.children,
          className = _props.className,
          hide = _props.hide,
          disableClick = _props.disableClick,
          height = _props.height,
          halign = _props.halign,
          valign = _props.valign,
          tdClassName = _props.tdClassName,
          other = _objectWithoutProperties(_props, ["blockName", "children", "className", "hide", "disableClick", "height", "halign", "valign", "tdClassName"]);

      var finalTdClassName = cx(tdClassName, (_cx = {}, _defineProperty(_cx, "".concat(tdClassName, "--valign-").concat(valign), valign), _defineProperty(_cx, "".concat(tdClassName, "--halign-").concat(halign), halign), _cx));
      var finalCellClassName = cx(blockName, className);
      var cellInnerClassName = "".concat(blockName, "-inner");
      return React.createElement("td", _extends({}, other, {
        className: finalTdClassName,
        onClick: this.onClick
      }), React.createElement("div", {
        className: finalCellClassName,
        style: {
          height: height
        }
      }, React.createElement("div", {
        className: cellInnerClassName
      }, children)));
    }
  }]);

  return TableRowColumn;
}(Component);

Object.defineProperty(TableRowColumn, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    /**
     * Children passed in the component.
     */
    children: PropTypes.node,

    /**
     * The CSS class name of the root element.
     */
    className: PropTypes.string,

    /**
     * Called when the column in row is clicked.
     */
    onClick: PropTypes.func,

    /**
     * The data needed to pass into onClick function
     */
    onClickParams: PropTypes.array,

    /**
     * Override the inline-styles of the root element
     */
    style: PropTypes.object,

    /**
     * Horizontal alignment
     */
    halign: PropTypes.oneOf(['left', 'center', 'right']),

    /**
     * Vertical alignment
     */
    valign: PropTypes.oneOf(['top', 'center', 'bottom'])
  }
});
Object.defineProperty(TableRowColumn, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    blockName: 'nx-table__cell',
    tdClassName: 'nx-table__td',
    halign: 'left',
    valign: 'center'
  }
});
export default TableRowColumn;